// extracted by mini-css-extract-plugin
export var displayNone = "_oa-6";
export var imgContainer = "_oa-2";
export var overflowHidden = "_oa-3";
export var productInfoCardButtonContainer = "_oa-5";
export var productTitleText = "_oa-4";
export var rightArrow = "_oa-1";
export var rightArrowContainer = "_oa-0";